import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider, Empty } from 'antd';
import App from 'src/containers/App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';

import FontFaceObserver from 'fontfaceobserver';

import './index.css';
import './styles/style.scss';
// import 'sanitize.css/sanitize.css';
import 'src/assets/fonts/fontawesome-pro-5.11.1-web/css/all.min.css';
import { Provider } from 'react-redux';
import { store } from './app/store';

if (process.env.NODE_ENV !== 'production') {
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;

  const shouldIgnoreMessage = (message?: unknown) => {
    if (typeof message !== 'string') {
      return false;
    }
    return message.includes(
      'Support for defaultProps will be removed from function components in a future major release',
    );
  };

  console.error = (...args: unknown[]) => {
    if (shouldIgnoreMessage(args[0])) {
      return;
    }
    originalConsoleError(...args);
  };

  console.warn = (...args: unknown[]) => {
    if (shouldIgnoreMessage(args[0])) {
      return;
    }
    originalConsoleWarn(...args);
  };
}

if (typeof window !== 'undefined' && window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      const wrappedCallback = (
        entries: ResizeObserverEntry[],
        observer: ResizeObserver
      ) => {
        requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (error: any) {
            throw error;
          }
        });
      };
      super(wrappedCallback);
    }
  };
}

const openSansObserver = new FontFaceObserver('Inter', {});

openSansObserver.load().then(() => {
  document.body.classList.add('fontLoaded');
});

ReactDOM.render(
  <HelmetProvider>
    <React.StrictMode>
      <ConfigProvider
        renderEmpty={() => (
          <Empty
            description="Không có dữ liệu"
            className="app-empty-state"
          />
        )}
      >
        <Provider store={store}>
          <App />
        </Provider>
      </ConfigProvider>
    </React.StrictMode>
  </HelmetProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
